export * from '@genstackio/react-context-api/lib/hooks/useConditionalMutationApi';
export { default as default } from '@genstackio/react-context-api/lib/hooks/useConditionalMutationApi';
